import { render, staticRenderFns } from "./ShopHome.vue?vue&type=template&id=5d88b852&scoped=true"
import script from "./ShopHome.vue?vue&type=script&lang=ts"
export * from "./ShopHome.vue?vue&type=script&lang=ts"
import style0 from "./ShopHome.vue?vue&type=style&index=0&id=5d88b852&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d88b852",
  null
  
)

export default component.exports